export default __webpack_public_path__ + "static/media/step_D_EN.c0b67071.png";